import './styles/index.scss';
import {isMobileDevice} from './js/utils';

document.body.className = isMobileDevice() ? 'mobile' : 'desktop';

